import createEatUp from "@/app";
import RestaurantApp from "./RestaurantApp.vue";
import router from "./router";
import { EAT_UP_PAGES } from "@/types";

createEatUp(RestaurantApp, router, EAT_UP_PAGES.RESTAURANT);
